import { AppBar, Badge, Box, Chip, Fab, FormLabel, Grid, Paper, Stack, Tooltip, Typography, Zoom, styled } from "@mui/material";
import { ReactNode, useState } from "react";
import { BodyStat, MindStat, SharpnesStat, SoulStat } from "../_/components/Stats";
import { dice } from "../content/dice";
import { Equipment } from "./Equipment";
import { Feats } from "./Feats";
import { Hp } from "./Hp";
import { Level } from "./Level";
import { Name } from "./Name";
import { Portrait } from "./Portrait";
import { CharacterStats, Stats } from "./Stats";
import { Backpack } from "../backpack/Backpack";
import { Skills } from "./Skills";
import { DiceIcon } from "../_/components/icons/Icons";
import { Row } from "../_/components/organization";
import PrintIcon from '@mui/icons-material/Print';
import { printStats } from "../_/utils/print";


export const StaticSheet = () => {
    return (
        <iframe src="pdf/sheet_editable.pdf" width="100%" height="100%">
        <a href="pdf/sheet_editable.pdf">Download</a>
    </iframe>
    )
}

export const Sheet = () => {

    const [stats, setStats] = useState<CharacterStats>(new CharacterStats())
    const st = new Stats(stats, setStats)


    const invalid = () => [stats.body, stats.mind, stats.sharpenss, stats.spirit].filter(item => item > 0).length < 2

    async function handlePrint() {
        printStats(stats)
    }

    return (
        <Box sx={{ flexGrow: 1, marginTop: 5 }} position={"relative"}>

            <Box width={"100%"} display="flex" justifyContent="flex-end" position={"absolute"}>
                <Fab size="small" onClick={handlePrint}>
                    <PrintIcon />
                </Fab>
            </Box>

            <Grid container spacing={2}>
                <Grid container spacing={2} xs={8} margin={0}>

                    {/* <Left xs={12}>{`nazwa: ${valueOrDash(stats.name)}`}</Left> */}
                    <Left xs={12}>
                        <Stack direction={'row'} spacing={2} alignItems="center" justifyContent="center">
                            <Name name={stats.name} onChange={st.name} />
                            <Level level={stats.level} onChange={st.level} />
                            <Hp stats={stats} />
                        </Stack>
                    </Left>

                    <Center xs={12}>
                        <Badge badgeContent={stats.free_stats} color="warning">
                            <Box paddingRight={2}>
                                Cechy
                            </Box>
                        </Badge>
                        <Stack direction="row" spacing={4} >
                            <Stack direction="column" alignItems="center">
                                <Typography component="legend">Ciało</Typography>
                                <BodyStat value={stats.body} onChange={st.body} />
                                <Row alignItems="center">
                                    <Typography fontSize="24px" component="legend">{dice(stats.body)}</Typography>
                                    <DiceIcon />
                                </Row>
                            </Stack>

                            <Stack direction="column" alignItems="center">
                                <Typography component="legend">Ostrość</Typography>
                                <SharpnesStat value={stats.sharpenss} onChange={st.sharpness} />
                                <Row alignItems="center">
                                    <Typography fontSize="24px" component="legend">{dice(stats.sharpenss)}</Typography>
                                    <DiceIcon />
                                </Row>
                            </Stack>

                            <Stack direction="column" alignItems="center">
                                <Typography component="legend">Umysł</Typography>
                                <MindStat value={stats.mind} onChange={st.mind} />
                                <Row alignItems="center">
                                    <Typography fontSize="24px" component="legend">{dice(stats.mind)}</Typography>
                                    <DiceIcon />
                                </Row>
                            </Stack>

                            <Stack direction="column" alignItems="center">
                                <Typography component="legend">Dusza</Typography>
                                <SoulStat value={stats.spirit} onChange={st.spirit} />
                                <Row alignItems="center">
                                    <Typography fontSize="24px" component="legend">{dice(stats.spirit)}</Typography>
                                    <DiceIcon />
                                </Row>
                            </Stack>
                            {stats.free_stats != 0 ?
                                <Tooltip title={"Punkty cech do rozdania"}>
                                    <Typography component="legend" variant="h5">{stats.free_stats}</Typography>
                                </Tooltip> : null
                            }
                        </Stack>
                        {invalid() && stats.free_stats == 0 &&
                            <FormLabel error={true}>
                                dwie statystyki muszą być większe niż 0
                            </FormLabel>
                        }
                    </Center>

                </Grid>
                <Grid xs={4} margin={0} container spacing={2}>
                    <Center xs={12}>
                        <Portrait portrait={stats.portrait} onChange={st.portrait} />
                    </Center>
                </Grid>
                <Center xs={6}>
                    <Equipment stats={stats} st={st} />
                </Center>

                <Center xs={6}>
                    <Skills stats={stats} setStats={st} />
                </Center>
                <Center xs={6}>
                    <Backpack stats={stats} setStats={st} />
                </Center>
                <Center xs={6}>
                    <Badge badgeContent={stats.freeFeats} color="warning">
                        <Box paddingRight={2}>
                            Atuty
                        </Box>
                    </Badge>
                    <Feats stats={stats} setStats={st} />
                </Center>

                <Left xs={8}>{`Majątek ${stats.wealth}`}</Left>
                <Center xs={4}>{`F©US`}</Center>

            </Grid>

            <Grid container spacing={2} direction={"column"} justifyContent={"center"}>

            </Grid>


        </Box >
    )
}


const Center = ({ children, xs }: { children: ReactNode, xs: number }) => (
    <Grid item xs={xs} >
        <CenterItem>{children}</CenterItem>
    </Grid>
)
const Left = ({ children, xs }: { children: ReactNode, xs: number }) => (
    <Grid item xs={xs} >
        <LeftItem>{children}</LeftItem>
    </Grid>
)

const CenterItem = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: "100%"
}));

const LeftItem = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "left",
    color: theme.palette.text.secondary,
    height: "100%"
}));


function valueOrDash<T>(param: T | null): T | string {
    if (param === null) {
        return "-";
    }
    return param;

}
